export default "__VITE_ASSET__WZXhI7eW__"